import { render, staticRenderFns } from "./MedicineAVB.vue?vue&type=template&id=4790e924"
import script from "./MedicineAVB.vue?vue&type=script&lang=js"
export * from "./MedicineAVB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports